export const CONTACT_INFO = {
  schoolName: 'Trường Mầm Non Trúc Xinh',
  slogan: 'Nơi bạn gửi trọn niềm tin',
  address: '614 Tôn Đức Thắng, Hòa Khánh, Đà Nẵng, Việt Nam',
  email: 'trucxinhkid@gmail.com',
  phone: '0236 3842 869',
  website: 'https://trucxinh.vn/',
  social: {
    facebook: 'https://www.facebook.com/MNTRUCXINH/',
    youtube: 'https://www.youtube.com/@mntrucxinhtruong5729',
  },
  mapUrl:
    'https://www.google.com/maps/search/?api=1&query=614+T%C3%B4n+%C4%90%E1%BB%A9c+Th%E1%BA%AFng%2C+H%C3%B2a+Kh%C3%A1nh%2C+%C4%90%C3%A0+N%E1%BA%B5ng%2C+Vi%E1%BB%87t+Nam',
  mapEmbedUrl:
    'https://www.google.com/maps?q=614+T%C3%B4n+%C4%90%E1%BB%A9c+Th%E1%BA%AFng,+H%C3%B2a+Kh%C3%A1nh,+%C4%90%C3%A0+N%E1%BA%B5ng,+Vietnam&output=embed&zoom=15',
}

export const BRAND_ASSETS = {
  logo: '/assets/images/LogoTrucXinh.png',
  social: {
    facebook: '/assets/images/FacebookIcon.png',
    youtube: '/assets/images/YouTubeIcon.png',
  },
}

export const TOPIC_OPTIONS = [
  {
    label: 'Chủ đề',
    items: [
      { value: 'gioi-thieu-chung', label: 'Giới thiệu chung' },
      { value: 'su-menh', label: 'Sứ mệnh & Tầm nhìn' },
      { value: 'co-so-vat-chat', label: 'Cơ sở vật chất' },
    ],
  },
]

export const SAMPLE_CONTENT: Record<
  string,
  {
    videoUrl: string
    script: string
  }
> = {}
